import styled from 'styled-components';

export const H2 = styled.h2`
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: 34px;
  line-height: 51px;
  color: ${({ theme }) => theme.algoanBlue};
  margin: 0;
`;
